// redux/store.js - Redux store configuration
import { configureStore, createSlice } from '@reduxjs/toolkit';

// Event categories slice
const eventCategoriesSlice = createSlice({
  name: 'eventCategories',
  initialState: {
   categories: [
      { id: 1, name: 'Corporate & Brand Events', icon: 'Business', count: 'Premium', color: '#6a11cb' },
      { id: 2, name: 'Weddings & Multi-Day Celebrations', icon: 'Favorite', count: 'Luxury', color: '#ff5e62' },
      { id: 3, name: 'Cultural & Traditional Functions', icon: 'Cake', count: 'Heritage', color: '#2575fc' },
      { id: 4, name: 'Luxury & Destination Events', icon: 'Groups', count: 'Exclusive', color: '#00b09b' },
      { id: 5, name: 'Product Launches', icon: 'RocketLaunch', count: 'Innovation', color: '#ff9966' },
      { id: 6, name: 'Music Concerts', icon: 'MusicNote', count: 'Vibrant', color: '#8e2de2' },
    ],
    selectedCategory: null,
  },
  reducers: {
    selectCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});

// Testimonials slice
const testimonialsSlice = createSlice({
  name: 'testimonials',
  initialState: {
    testimonials: [
      { id: 1, name: 'Amit Basu', role: 'Marketing Director', company: 'TechCorp', content: 'The team transformed our annual conference into an unforgettable experience. Professional, creative, and efficient!', rating: 5, avatarColor: '#6a11cb' },
      { id: 2, name: 'Somnath Chowdhury', role: 'CEO', company: 'EALP', content: 'Our product launch exceeded all expectations. The attention to detail was remarkable.', rating: 5, avatarColor: '#2575fc' },
      { id: 3, name: 'Sudipta Das', role: 'Bride', company: '', content: 'Our wedding was absolutely perfect. They handled everything seamlessly, allowing us to enjoy our special day.', rating: 5, avatarColor: '#ff5e62' },
      { id: 4, name: 'Rita Roy', role: 'HR Manager', company: 'Global Inc', content: 'The team-building event organized by Elevate Events boosted employee morale significantly.', rating: 4, avatarColor: '#00b09b' },
    ],
  },
  reducers: {},
});

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    formData: {
      name: '',
      email: '',
      phone: '',
      eventType: '',
      date: '',
      guests: '',
      message: '',
    },
    submitted: false,
    loading: false,
  },
  reducers: {
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    submitForm: (state) => {
      state.loading = true;
    },
    submitFormSuccess: (state) => {
      state.loading = false;
      state.submitted = true;
      state.formData = {
        name: '',
        email: '',
        phone: '',
        eventType: '',
        date: '',
        guests: '',
        message: '',
      };
    },
    submitFormFailure: (state) => {
      state.loading = false;
    },
    resetForm: (state) => {
      state.submitted = false;
    },
  },
});

export const { selectCategory } = eventCategoriesSlice.actions;
export const { updateFormData, submitForm, submitFormSuccess, submitFormFailure, resetForm } = contactSlice.actions;

export const store = configureStore({
  reducer: {
    eventCategories: eventCategoriesSlice.reducer,
    testimonials: testimonialsSlice.reducer,
    contact: contactSlice.reducer,
  },
});